import { produce } from "immer";

const shippingAddressReducer = (
    state = {
        loading: false,
        addresses: [],
        currentAddress: null,
        error: null,
        showForm: false,
    },
    action
) => {
    switch (action.type) {
        case "GET_SHIPPING_ADDRESSES_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "GET_SHIPPING_ADDRESSES_SUCCESS":
            return {
                ...state,
                addresses: Array.isArray(action.payload) ? action.payload : [],
                loading: false,
                error: null,
            };
        case "GET_SHIPPING_ADDRESSES_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "GET_SHIPPING_ADDRESS_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "GET_SHIPPING_ADDRESS_SUCCESS":
            return {
                ...state,
                currentAddress: action.payload,
                loading: false,
                error: null,
            };
        case "GET_SHIPPING_ADDRESS_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "UPDATE_SHIPPING_ADDRESS_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "UPDATE_SHIPPING_ADDRESS_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                if (draft.addresses && action.payload) {
                    const idx = draft.addresses.findIndex(
                        (addr) => addr.address_id === action.payload.address_id
                    );
                    if (idx !== -1) {
                        draft.addresses[idx] = action.payload;
                    }
                }
                if (draft.currentAddress && action.payload?.address_id === draft.currentAddress.address_id) {
                    draft.currentAddress = action.payload;
                }
            });
        case "UPDATE_SHIPPING_ADDRESS_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "DELETE_SHIPPING_ADDRESS_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "DELETE_SHIPPING_ADDRESS_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                if (draft.addresses && action.payload?.address_id) {
                    draft.addresses = draft.addresses.filter(
                        (addr) => addr.address_id !== action.payload.address_id
                    );
                }
                if (draft.currentAddress?.address_id === action.payload?.address_id) {
                    draft.currentAddress = null;
                }
            });
        case "DELETE_SHIPPING_ADDRESS_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "SET_MAIN_SHIPPING_ADDRESS_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "SET_MAIN_SHIPPING_ADDRESS_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                if (draft.addresses && action.payload) {
                    // Set all addresses to not main, then set the selected one as main
                    draft.addresses = draft.addresses.map(addr => ({
                        ...addr,
                        is_main: addr.address_id === action.payload.address_id
                    }));
                }
            });
        case "SET_MAIN_SHIPPING_ADDRESS_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "CREATE_SHIPPING_ADDRESS_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "CREATE_SHIPPING_ADDRESS_SUCCESS":
            return produce(state, (draft) => {
                draft.loading = false;
                draft.error = null;
                if (action.payload && draft.addresses) {
                    draft.addresses.push(action.payload);
                }
            });
        case "CREATE_SHIPPING_ADDRESS_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "OPEN_SHIPPING_ADDRESS_FORM":
            return {
                ...state,
                showForm: true,
            };
        case "CLOSE_SHIPPING_ADDRESS_FORM":
            return {
                ...state,
                showForm: false,
            };
    }
    return state;
};

export default shippingAddressReducer;

